module.exports = {
    "collectionLabel": `Soovitused`
};


//# sourceMappingURL=et-EE.main.js.map
